import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../apiCall";
import { encrypt } from "../crypto";
import { Toaster, toast } from "react-hot-toast";

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);

  const handleSubmit = async () => {
    if (!username || !password) {
      toast.error("Please fill in all values");
    } else {
      apiRequest(
        "POST",
        "/admin-user/",
        { username, password: encrypt(password) },
        false,
        false
      )
        .then((res) => {
          if (res.status === 200) {
            localStorage.removeItem("userData");
            localStorage.removeItem("userToken");
            localStorage.setItem("adminData", JSON.stringify(res.data));
            localStorage.setItem("adminToken", res.data.Token); 

            
            navigate("/admin/", { state: { Role: res.data.Role } });
          } else if (res.status === 500) {
            toast.error("User not found");
          } else {
            toast.error("Wrong password");
          }
        })
        .catch((error) => {
          console.error("Error logging in:", error);
          toast.error("An error occurred while logging in");
        });
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };
  return (
    <div className="login">
      <div style={{ background: "#6f9278", width: "100%", height: "100vh" }}>
        <div className="auth" style={{ background: "#245369", color: "white" }}>
          <h2>Admin Log in</h2>
          <p>Please enter your details</p>

          <input
            type="text"
            placeholder="Username"
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
          />
          <input
            type="password"
            placeholder="Password"
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <button onClick={handleSubmit}>Log in</button>
        </div>
        <Toaster position="top right" />
      </div>
    </div>
  );
}
